export class SmartphoneDetails {
    id: number;
    serialNbr: string;
    nbr: string;
    hint: string;
    available: boolean;
}
